// The events that the machine handles
export enum ClaimEvent {
  CLAIM = 'CLAIM',
  CHECK_CONDITIONS = 'CHECK_CONDITIONS',
  UPDATE_ACCOUNT_INFO = 'UPDATE_ACCOUNT_INFO',
}
